import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/store';
import { getCurrentUserThunk } from '../../../../services/userService/userThunk';
export const UserRawDataModal = ({
  isModalOpen,
  onCloseModal,
  userId,
}: {
  isModalOpen: boolean;
  onCloseModal: any;
  userId: string | null;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  const [result, setResult] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getCurrentUserThunk({ userId }))
      .unwrap()
      .then((res) => {
        setResult(res);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [userId]);

  return (
    <Modal
      title="Raw Data"
      open={isModalOpen}
      onOk={onCloseModal}
      onCancel={onCloseModal}
      width={1200}
    >
      {isLoading ? <div>Loading...</div> : <pre>{JSON.stringify(result, null, 2)}</pre>}
    </Modal>
  );
};
